import { useFetchClubsToAddQuery,useAddClubMutation } from "../../store/club/ClubApi";
import * as React from 'react'
import { Autocomplete, Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useNavigate } from "react-router";

export function ClubCreate() 
{
  console.info("ClubCreate");

  // Ermitteln der übergebenen Parameter
  const params = useParams();
  const selectedYear = params.year;
  const [clubName, setClubName] = React.useState('')  
  const navigate = useNavigate();
  const {data:clubList, isLoading:clubListIsLoading} = useFetchClubsToAddQuery(selectedYear);
  const [addClub] = useAddClubMutation();


  /*
  * Klicken für einen neuen Verein
  */
  const onClick = (event) => {
    // Sicherstellen, dass sonst nicht noch etwas anderes ausgeführt wird
    event.defaultMuiPrevented = true;
    
    // Nun ermitteln wir den passenden Verein und suchen diesen in der Clubliste
    let club = clubList.find((club) => club.name === clubName);
    club = {
      ...club, 
      year : selectedYear,
    }

    try 
    {
      //const newClub = 
      addClub(club)
      .unwrap()
      .then(
        (payload) => 
        {    
          // und jetzt springen wir weiter
          navigate("/" + selectedYear + "/" + payload.label + "/" );
          return payload.club;
        }
      );

    } 
    catch (err) 
    {
      console.error('Fehler beim Anmelden des Vereins...: ', err)
    }      
  };
    

  if (clubListIsLoading)
  {
    return (
      <CircularProgress />
    );
  }
  else
  {
    return (      
      <Stack spacing={2} direction="row">
        <Autocomplete
          options={clubList ?? []}
          groupBy={(club) => club.city}
          getOptionLabel={(club) => club.name}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Verein" />}
          onInputChange={(event, newInputValue) => {
            setClubName(newInputValue);
          }}
        />
        <Button 
          variant="contained"
          onClick={onClick}
        >Verein&nbsp;<Typography color="secondary">{clubName}</Typography>&nbsp;anmelden</Button>
      </Stack>
    );
  } 
}
